﻿export class Country implements ICountry {

    static regions: {[name: string]: ICountryRegion} = require("../data/CountryRegion.json");
    static byName: ICountry[] = require("../data/Country.json");
    static byCode: ICountry[] = [...Country.byName];

    static initialize() {
        Country.byName.sort((a, b) => a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
        Country.byCode.sort((a, b) => a.countryCode < b.countryCode ? -1 : a.countryCode > b.countryCode ? 1 : 0);
        for (const country of Country.byName)
            if (country.provinces && country.provinces.length > 0)
                country.provinces.sort((a, b) => a.stateOrProvince < b.stateOrProvince ? -1 : a.stateOrProvince > b.stateOrProvince ? 1 : 0);
    }

    static defaultCode = "USA";

    private find(code: string): ICountry|undefined {
        let b = 0, e = Country.byCode.length - 1;
        while (b <= e) {
            const m = Math.floor((b + e) / 2);
            if (Country.byCode[m].countryCode === code) return Country.byCode[m];
            else if (Country.byCode[m].countryCode < code) b = m + 1;
            else e = m - 1;
        }
        return Country.byCode[0];
    }

    constructor(code: string) {
        this._country = this.find(code);
    }

    toJSON(key?: string): string {
        // return generic object with properties to stringify
        return this.countryCode;
    }

    private _country?: ICountry;

    get countryCode(): string {
        return this._country?.countryCode ?? "";
    }

    get iso2(): string {
        return this._country?.iso2 ?? "";
    }

    get name(): string {
        return this._country?.name ?? "";
    }

    get region1Code(): string {
        return this._country?.region1Code ?? "";
    };

    get region2Code(): string {
        return this._country?.region2Code ?? "";
    }

    get postalFormat(): string {
        return this._country?.postalFormat ?? "";
    }

    get localizedNames(): {[culture: string]: string} {
        return this._country?.localizedNames ?? {};
    }

    get provinces(): ICountryProvince[] {
        return this._country?.provinces ?? [];
    }

    get region1Name(): string {
        return Country.regions[this.region1Code]?.name ?? "";
    }

    get region2Name(): string {
        return Country.regions[this.region1Code]?.subregions?.[this.region2Code] ?? "";
    }

    get locale(): ICountryLocale {
        // Determine the visibility, label, width, and order of city, stateorprovince, and postalcode fields
        const position: number[] = [];
        const name: string[] = [];
        const rx = /\{(\d+)(?::(.+?))?\}/g;
        let match = rx.exec(this.postalFormat);
        while (match) {
            position.push(parseInt(match[1]));
            name.push(parseInt(match[1]) !== 2 ? match[2] : this.countryCode === Country.defaultCode ? "zip code" : "postal code");
            match = rx.exec(this.postalFormat);
        }
        const i = position.indexOf(2);
        const width = position.length <= 1 ? [100, 100, 100]
            : i === 0 ? [40, 60, 100]
            : i === 2 ? [100, 60, 40]
            : i === -1 ? [50, 50, 100]
            : (position.length === 3 && position[2] === 1) ? [100, 40, 60]
            : [60, 40, 100];

        return { position: position, name: name, width: width, country: this };
    }
}

export interface ICountry {
    countryCode: string;
    iso2: string;
    name: string;
    region1Code: string;
    region2Code: string;
    postalFormat: string;
    localizedNames?: {[culture: string]: string}|undefined;
    provinces?: ICountryProvince[];
}

export interface ICountryProvince {
    stateOrProvince: string;
    name: string;
}

export interface ICountryRegion {
    name: string;
    subregions?: {[name: string]: string};
}

export interface ICountryLocale {
    position: number[];
    name: string[];
    width: number[];
    country: Country;
}

Country.initialize();